<div #containerRef class="viewer-container">
  <ng-container *ngIf="!minimal">
    <app-three-sixty-viewer-label [label]="'JUPITER.VIEW_360.TITLE'"></app-three-sixty-viewer-label>
    <nz-divider [style.margin.px]="0"></nz-divider>
  </ng-container>

  <div class="viewer-wrapper">
    <button *ngIf="!minimal" class="open-modal-btn" nz-button (click)="openModal()">
      <i nz-icon nzType="fullscreen" nzTheme="outline"></i>
    </button>
    <canvas #canvasRef></canvas>
  </div>

  <app-three-sixty-viewer-controls
    [isAutoplaying]="isAutoplaying"
    [progressOffset]="progressOffset"
    [circumference]="circumference"
    (prevFrameHold)="prevFrame()"
    (nextFrameHold)="nextFrame()"
    (stopHold)="stopHold()"
    (toggleAutoplay)="toggleAutoplay()"
  ></app-three-sixty-viewer-controls>
</div>
